import { Pipe, PipeTransform } from '@angular/core';

const cpfLength = 12;
@Pipe({ name: 'cpfCnpjFormatted' })
export class CpfCnpjFormattedPipe implements PipeTransform {
  transform(cpfCnpj: string, tipo?: string): string {
    const cpf = 'Física';
    const cnpj = 'Jurídica';
    const radical = 'Radical';
    if (!cpfCnpj) {
      return '';
    }

    switch (tipo) {
      case cpf:
        return this.formatarCpf(cpfCnpj);
      case cnpj:
        return this.formatarCnpj(cpfCnpj);
      case radical:
        return this.formatarRadical(cpfCnpj);
      default:
        return this.formatarCpfCnpjNumerico(cpfCnpj);
    }
  }

  private formatarCpfCnpjNumerico(cpfCnpj: string): string {
    cpfCnpj = cpfCnpj.replace(/\D/g, '');

    if (cpfCnpj.length < cpfLength) {
      cpfCnpj = cpfCnpj.replace(/(\d{3})(\d)/, '$1.$2');
      cpfCnpj = cpfCnpj.replace(/(\d{3})(\d)/, '$1.$2');
      cpfCnpj = cpfCnpj.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
      cpfCnpj = cpfCnpj.replace(/^(\d{2})(\d)/, '$1.$2');
      cpfCnpj = cpfCnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      cpfCnpj = cpfCnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
      cpfCnpj = cpfCnpj.replace(/(\d{4})(\d)/, '$1-$2');
    }
    return cpfCnpj;
  }

  private formatarCpf(cpfCnpj: string): string {
    const ponto = 3;
    const traco = 2;
    const primeiraPos = 0;
    const segundaPos = 3;
    const terceiraPos = 6;
    const quartaPos = 9;
    const tamanhoCpf = 11;
    cpfCnpj = cpfCnpj.padStart(tamanhoCpf, '0');
    const str1: string = cpfCnpj.substr(primeiraPos, ponto);
    const str2: string = cpfCnpj.substr(segundaPos, ponto);
    const str3: string = cpfCnpj.substr(terceiraPos, ponto);
    const str4: string = cpfCnpj.substr(quartaPos, traco);
    return `${str1}.${str2}.${str3}-${str4}`;
  }

  private formatarRadical(cpfCnpj: string): string {
    const tamanhoRadical = 8;
    cpfCnpj = cpfCnpj.padStart(tamanhoRadical, '0');
    const ponto = 3;
    const traco = 2;
    const primeiraPos = 0;
    const segundaPos = 2;
    const terceiraPos = 5;
    cpfCnpj = cpfCnpj.padStart(tamanhoRadical, '0');
    const str1: string = cpfCnpj.substr(primeiraPos, traco);
    const str2: string = cpfCnpj.substr(segundaPos, ponto);
    const str3: string = cpfCnpj.substr(terceiraPos, ponto);
    return `${str1}.${str2}.${str3}`;
  }

  private formatarCnpj(cpfCnpj: string): string {
    const tamanhoCnpj = 14;
    cpfCnpj = cpfCnpj.padStart(tamanhoCnpj, '0');
    const ponto = 3;
    const traco = 2;
    const barra = 4;
    const primeiraPos = 0;
    const segundaPos = 2;
    const terceiraPos = 5;
    const quartaPos = 8;
    const quintaPos = cpfLength;
    cpfCnpj = cpfCnpj.padStart(tamanhoCnpj, '0');
    const str1: string = cpfCnpj.substr(primeiraPos, traco);
    const str2: string = cpfCnpj.substr(segundaPos, ponto);
    const str3: string = cpfCnpj.substr(terceiraPos, ponto);
    const str4: string = cpfCnpj.substr(quartaPos, barra);
    const str5: string = cpfCnpj.substr(quintaPos, traco);
    return `${str1}.${str2}.${str3}/${str4}-${str5}`;
  }
}
